import investingConfig from './investing-brokerage-table';
export default {
  investingBrokerage: investingConfig
};